export const learningAccessCopy = {
  title: { id: 'Akses Belajar Khusus Peserta', ar: 'صلاحيات تعلم خاصة للمشارك' },
  intro: {
    id: 'Buka mata pelajaran untuk peserta ini tanpa mengubah aturan peserta lain. Izin melewati kunci level sebelumnya dan prasyarat mata pelajaran, bukan memberi nilai atau kelulusan.',
    ar: 'افتح المواد لهذا المشارك دون تغيير قواعد الآخرين. يتجاوز الإذن قفل المستوى السابق والمتطلبات، ولا يمنح درجات أو نجاحاً.',
  },
  level: { id: 'Pilih level', ar: 'اختر المستوى' },
  allLevels: { id: 'Semua level', ar: 'كل المستويات' },
  search: { id: 'Cari mata pelajaran atau kode', ar: 'ابحث عن مادة أو رمز' },
  selectVisible: { id: 'Pilih semua yang ditampilkan', ar: 'اختر كل المواد الظاهرة' },
  clear: { id: 'Hapus pilihan', ar: 'إلغاء الاختيار' },
  selected: { id: '{count} mata pelajaran dipilih', ar: 'تم اختيار {count} مادة' },
  summary: {
    id: '{credited} diakui dari nilai lama · {granted} izin akses aktif',
    ar: '{credited} معترف بها من السجل القديم · {granted} صلاحية نشطة',
  },
  active: { id: 'Izin akses aktif', ar: 'صلاحية نشطة' },
  ordinary: { id: 'Mengikuti aturan kurikulum', ar: 'يتبع قواعد المنهج' },
  recognized: { id: 'Nilai lama diakui: {score}%', ar: 'درجة قديمة معترف بها: {score}٪' },
  allSessions: {
    id: 'Buka semua pertemuan dan materi dalam mata pelajaran terpilih',
    ar: 'افتح كل اللقاءات والمواد في المواد المختارة',
  },
  sessionsHint: {
    id: 'Bawaan: urutan pertemuan dan kewajiban lulus evaluasi sebelumnya tetap berlaku. Jika dicentang, kunci tersebut dilewati hanya untuk materi terpilih. Ujian tetap membutuhkan materi selesai; nilai, batas percobaan dan reset tidak berubah.',
    ar: 'افتراضياً يبقى ترتيب اللقاءات وشرط نجاح التقييم السابق. عند التحديد يتم تجاوز هذه الأقفال للمواد المختارة فقط. تبقى الاختبارات مشروطة بإكمال المواد ولا تتغير الدرجات أو المحاولات أو إعادة الضبط.',
  },
  reason: {
    id: 'Alasan izin / pencabutan (minimal 5 karakter)',
    ar: 'سبب الإذن أو الإلغاء (5 أحرف على الأقل)',
  },
  confirmation: {
    id: 'Ketik BUKA untuk memberi izin atau CABUT untuk mencabut',
    ar: 'اكتب BUKA لمنح الإذن أو CABUT لإلغائه',
  },
  grant: { id: 'Buka akses terpilih', ar: 'افتح الصلاحيات المختارة' },
  revoke: { id: 'Cabut izin terpilih', ar: 'ألغ الصلاحيات المختارة' },
  revokeHint: {
    id: 'Pencabutan hanya untuk izin aktif. Kembali ke aturan kurikulum; materi yang sudah selesai dan nilai asli tidak dihapus.',
    ar: 'الإلغاء للصلاحيات النشطة فقط. يعود المشارك لقواعد المنهج دون حذف الإكمال أو الدرجات الأصلية.',
  },
  saved: {
    id: 'Izin tersimpan dengan jejak audit. Peserta dapat memuat ulang Program Saya. Tidak ada nilai atau kelulusan yang ditambahkan.',
    ar: 'تم حفظ الإذن مع سجل تدقيق. يمكن للمشارك تحديث برامجي. لم تتم إضافة درجات أو نجاح.',
  },
  loading: { id: 'Memuat akses peserta…', ar: 'جار تحميل الصلاحيات…' },
  loadError: {
    id: 'Akses belum dapat dimuat. Coba muat ulang.',
    ar: 'تعذر تحميل الصلاحيات. حاول مجدداً.',
  },
  retry: { id: 'Muat ulang', ar: 'إعادة التحميل' },
  empty: { id: 'Tidak ada mata pelajaran sesuai pencarian.', ar: 'لا توجد مواد مطابقة للبحث.' },
  failed: {
    id: 'Penyimpanan izin belum dapat dipastikan. Periksa pesan dan muat ulang izin sebelum mencoba kembali.',
    ar: 'تعذر تأكيد حفظ الإذن. تحقق من الرسالة وحدّث الصلاحيات قبل المحاولة مجدداً.',
  },
};
